import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import { FirebaseError } from 'firebase/app';

import { HotelDocumentFirestoreResponse } from '../../types';
import { fetchDocumentById } from '../utils';

const COLLECTION_PATH = 'hotels';

export const useGetHotelDocumentFromFirestore = (
  documentId: string | null | undefined,
  options?: UseQueryOptions<HotelDocumentFirestoreResponse | null, FirebaseError>,
): UseQueryResult<HotelDocumentFirestoreResponse | null, FirebaseError> => useQuery<
    HotelDocumentFirestoreResponse | null, FirebaseError>({
      queryKey: [`hotel-${documentId}`] as const,
      queryFn: async (): Promise<HotelDocumentFirestoreResponse | null> => {
        const data = await fetchDocumentById<HotelDocumentFirestoreResponse>(COLLECTION_PATH, documentId);
        return data
          ? {
            id: data.id,
            name: data.name,
            brand_url: data.brand_url,
            cover_photo: data.cover_photo,
            email: data.email,
            phone: data.phone,
            address: {
              city_name: data.address.city_name,
              city: data.address.city,
              number: data.address.number,
              street: data.address.street,
              postal_code: data.address.postal_code,
              geoPoint: data.address.geoPoint,
            },
            stars: data.stars,
            chatAvailable: data.chatAvailable,
            mobileAppAvailable: data.mobileAppAvailable,
          }
          : null;
      },
      enabled: !!documentId,
      retry: 0,
      ...options,
    });
